import { formatNumber } from 'modules/I18N';

interface NumberRendererProps {
  value: number | null;
  localeCode: string | null;
}

const NumberRenderer = ({ value, localeCode }: NumberRendererProps): string | null => {
  if (value === null || localeCode === null) {
    return null;
  }

  return formatNumber({ value, localeCode });
};

export default NumberRenderer;
